module.exports = __webpack_public_path__ + "img/Shift2DC_logo.58de07d6.png";